import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class OpenTicketIssueType extends Component {
    state = {
        OpenTicketIssueTypeLists:[],
        OpenTicketIssueTypeValue: '',
        isOpenTicketIssueTypeLoading: true
    };
    componentDidMount(){
        this.getOpenTicketIssueType();
    }
    restOpenTicketIssueTypeFilter() {
        this.setState({
            OpenTicketIssueTypeValue: [],
        })
    }
    getOpenTicketIssueType(){
        axios.get(config.get('API_URL')+'/filters/get-issue-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issue_type, index) => {
                    this.state.OpenTicketIssueTypeLists.push({value: issue_type.issue_type, label: issue_type.issue_type})
                });
            }
            this.setState({
                isOpenTicketIssueTypeLoading: false
            })
        });

    }


    changeOpenTicketIssueType(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.OpenTicketIssueTypeLists.findIndex(obj => obj.value==ids.value);
                this.state.OpenTicketIssueTypeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectOpenTicketIssueType(optionSelected, tenderArray);
        this.setState({
            OpenTicketIssueTypeValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.OpenTicketIssueTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeOpenTicketIssueType.bind(this)}
                options={this.state.OpenTicketIssueTypeLists}
                placeholderButtonLabel="Select [Issue Type]"
                isLoading={this.state.isOpenTicketIssueTypeLoading}
            />
        );

    }
}
export default OpenTicketIssueType;